import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RiskItem } from '../data-layer/inherentRisksTypes';

interface InherentRisksState {
  risks: RiskItem[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
  filters: {
    includeDetails: boolean;
    includeViolationSummary: boolean;
    riskKeys?: number[] | null;
    columnToSort: string;
    globalSearch: string | null;
    max: number;
    offset: number;
    order: string;
  };
}

const initialState: InherentRisksState = {
  risks: [],
  totalRecords: 0,
  loading: false,
  error: null,
  filters: {
    includeDetails: false,
    includeViolationSummary: false,
    riskKeys: [],
    columnToSort: 'riskName',
    globalSearch: '',
    max: 25,
    offset: 0,
    order: 'DESC',
  },
};

const inherentRisksSlice = createSlice({
  name: 'inherentRisks',
  initialState,
  reducers: {
    setRisksData: (state, action: PayloadAction<RiskItem[]>) => {
      state.risks = action.payload;
    },
    setRisksTotalRecords: (state, action: PayloadAction<number>) => {
      state.totalRecords = action.payload;
    },
    setRisksIsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRisksError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateRisksFilters: (
      state,
      action: PayloadAction<Partial<InherentRisksState['filters']>>
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetRisksFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const {
  setRisksData,
  setRisksTotalRecords,
  setRisksIsLoading,
  setRisksError,
  updateRisksFilters,
  resetRisksFilters,
} = inherentRisksSlice.actions;

export default inherentRisksSlice.reducer;
